import murmur from '../../engine/engine/murmur3/murmur3';
import { buildKey } from './buildKey';
export function hashImpression32(impression) {
  return murmur.hash(buildKey(impression));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/impressions/hasher/hashImpression32.js
// module id = 2832
// module chunks = 39